module.exports = __webpack_public_path__ + "img/x1.6cc64728.jpg";